export const SET_LOCALE = 'SET_LOCALE'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const PERMISSION = 'PERMISSION'
export const SET_PERMISSION = 'SET_PERMISSION'
export const SET_REFRESHED_TOKEN = 'SET_REFRESHED_TOKEN'
export const SET_CLIENT_TYPE = 'SET_CLIENT_TYPE'
export const SET_WEB_VIEW = 'SET_WEB_VIEW'
export const SET_FINGERPRINT = 'SET_FINGERPRINT'

export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS'
export const SET_BREADCRUMB = 'SET_BREADCRUMB'
export const SET_DOWNLOAD_PROGRESS = 'SET_DOWNLOAD_PROGRESS'
export const SET_OFFLINE = 'SET_OFFLINE'

export const SET_MAP_OPTIONS = 'SET_MAP_OPTIONS'

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

export const LOCALE_COOKIE = 'aloc'
export const ACCOUNT_COOKIE = 'wacc'

// ------------  register order -------------
export const CHANGE_COORDINATES = 'CHANGE_COORDINATES'
export const RESET_COORDINATES = 'RESET_COORDINATES'
export const CHANGE_ORDER_BY_KEY = 'CHANGE_ORDER_BY_KEY'
export const CHANGE_POINT_INFO_BY_KEY = 'CHANGE_POINT_INFO_BY_KEY'
export const LOAD_ORDER = 'LOAD_ORDER'

/* -------new order-------- */
export const SET_ORDER_RANGE = 'SET_ORDER_RANGE'
export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY'
export const SET_POINT_INFO = 'SET_POINT_INFO'
export const CLEAR_POINT_INFO = 'CLEAR_POINT_INFO'
export const SET_POINT_INFO_BY_KEY = 'SET_POINT_INFO_BY_KEY'
export const UPDATE_ORDER_BY_KEY = 'UPDATE_ORDER_BY_KEY'
export const CHANGE_ORDER_WITH_CAR = 'CHANGE_ORDER_WITH_CAR'
export const SET_FETCHED_LIST_DATE = 'SET_FETCHED_LIST_DATA'
export const SET_ORDER_OFFERS = 'SET_ORDER_OFFERS'
export const RESET_STORE = 'RESET_STORE'
export const SET_ENTIRE_ORDER = 'SET_ENTIRE_ORDER'
export const SET_MIDDLE_POINT_INFO_BY_INDEX = 'SET_MIDDLE_POINT_INFO_BY_INDEX'

export const SET_FIREBASE_MESSAGING_TOKEN = 'SET_FIREBASE_MESSAGING_TOKEN'

// --- create Shipment Refactor --- //
export const WIPE_ORDER_DATA = 'WIPE_ORDER_DATA'
export const SET_ORDER_CONFIG = 'SET_ORDER_CONFIG'
export const SET_ORDER_OBJECT = 'SET_ORDER_OBJECT'
export const SET_ORDER_STEP = 'SET_ORDER_STEP'
export const SET_ORDER_STEP_SECTION = 'SET_ORDER_STEP_SECTION'

export const SET_ORDER_POINT_DATA = 'SET_ORDER_POINT_DATA'
export const SET_ORDER_POINT_DATA_BY_KEY = 'SET_ORDER_POINT_DATA_BY_KEY'
export const REGISTER_ORDER_NEXT_STEP = 'REGISTER_ORDER_NEXT_STEP'
export const REGISTER_ORDER_PREV_STEP = 'REGISTER_ORDER_PREV_STEP'
export const SET_ORDER_DATA_BY_KEY = 'SET_ORDER_DATA_BY_KEY'
export const SET_ORDER_CACHE_DATA_BY_KEY = 'SET_ORDER_CACHE_DATA_BY_KEY'

// actions
export const ACTION_FETCH_CAR_LIST = 'ACTION_FETCH_CAR_LIST'
export const ACTION_FETCH_EMPLOYEE_LIST = 'ACTION_FETCH_EMPLOYEE_LIST'
export const ACTION_FETCH_ITEM_LIST = 'ACTION_FETCH_ITEM_LIST'
export const ACTION_FETCH_CITY_LIST = 'ACTION_FETCH_CITY_LIST'
export const ACTION_FETCH_LOAD_LIST = 'ACTION_FETCH_LOAD_LIST'
export const ACTION_FETCH_PACKAGE_TYPE_LIST = 'ACTION_FETCH_PACKAGE_TYPE_LIST'
export const ACTION_SET_ORDER_ACCEPTED_OFFERS =
  'ACTION_SET_ORDER_ACCEPTED_OFFERS'
export const SET_ORDER_PACKAGE_FIELD_BY_INDEX_AND_KEY =
  'SET_ORDER_PACKAGE_FIELD_BY_INDEX_AND_KEY'
export const WIPE_ORDER_POINT_DATA = 'WIPE_ORDER_POINT_DATA'

export const SET_ORDER_TYPE = 'SET_ORDER_TYPE'
export const SET_USER_DATA = 'SET_USER_DATA'

export const SET_ORDER_MIDDLE_POINT_DATA_BY_INDEX =
  'SET_ORDER_MIDDLE_POINT_DATA_BY_INDEX'
export const REGISTER_ORDER_SET_STEP = 'REGISTER_ORDER_SET_STEP'
export const SET_ORDER_ACCEPTED_OFFERS = 'SET_ORDER_ACCEPTED_OFFERS'
export const SET_ORDER_POINT_DATA_BY_SAVED_ADDRESS =
  'SET_ORDER_POINT_DATA_BY_SAVED_ADDRESS'
export const SET_ORDER_POINTS = 'SET_ORDER_POINTS'
export const ACTION_FETCH_CAR_CATEGORY_LIST = 'ACTION_FETCH_CAR_CATEGORY_LIST'
export const SET_ORDER_POINT_DATA_BY_INDEX_KEY =
  'SET_ORDER_POINT_DATA_BY_INDEX_KEY'
export const REMOVE_ORDER_POINT_BY_INDEX = 'REMOVE_ORDER_POINT_BY_INDEX'
